<span class="label  mt-1 me-1 {{color}} {{customClass}}  "  [ngStyle]='customStyle'>
  <ng-content></ng-content>
</span>
